import { useEffect, useState } from 'react';
import { useLocaleState } from 'react-admin';

import { fetchReviewGrid } from '../../services/api';

// The grid follows the language picked in the interface. Not cached across mounts on purpose: it
// carries is_manager, which depends on who is logged in.
const useReviewGrid = () => {
    const [lang] = useLocaleState();
    const [grid, setGrid] = useState(null);

    useEffect(() => {
        let active = true;
        fetchReviewGrid(lang).then(data => {
            if (active) {
                setGrid(data);
            }
        });
        return () => {
            active = false;
        };
    }, [lang]);

    return grid;
};

export const levelLabel = (grid, score) => grid?.levels?.find(level => level.value === score)?.label;

export const targetFor = (grid, stage, block) => grid?.targets?.[stage]?.[block] ?? null;

export const axesByBlock = (grid) => (grid?.blocks || []).map(block => ({
    ...block,
    axes: grid.axes.filter(axis => axis.block === block.key)
}));

export default useReviewGrid;
